import React, { PropTypes } from 'react';
import B from 'bem-cn';
import { Card, CardText } from 'react-toolbox/lib/card';

import getStaticContent from '../../utils/getStaticContent';

import './index.scss';

const cl = B('Benefits');

export default class Benefits extends React.Component {
  constructor(props) {
    super(props);
    this.staticContent = getStaticContent('benefits', props.currentPageName);
  }

  static propTypes = {
    currentPageName: PropTypes.string.isRequired
  };

  getBenefitItem(str) {
    return str.replace(/\*\*/g, '');
  }

  getBenefit(idx) {
    const benefit = this.staticContent.content[idx];
    return (
      <Card
        theme={{
          card: cl('item', {
            type: benefit.type,
            centered: idx === 3 || idx === 1
          })
        }}
      >
        <div className={cl('itemTitle')}>{benefit.title}</div>
        <CardText className={cl('itemContent').toString()}>
          <ul className={cl('list')}>
            {benefit.items.map((item, itemIndex) => (
              <li key={itemIndex}>{this.getBenefitItem(item)}</li>
            ))}
          </ul>
        </CardText>
      </Card>
    );
  }

  render() {
    return (
      <div className={cl} id="benefits">
        <div className={cl('title')}>
          {this.staticContent.title}
        </div>
        <div
          className={cl('benefitsHolder').mix(
            'row hidden visible-md visible-lg'
          )}
        >
          <div className="col-md-4">
            {this.getBenefit(3)}
          </div>
          <div className="col-md-4">
            {this.getBenefit(0)}
            {this.getBenefit(2)}
          </div>
          <div className="col-md-4">
            {this.getBenefit(1)}
          </div>
        </div>
        <div
          className={cl('medium-phone-block').mix('row hidden-md hidden-lg')}
        >
          <div className="col-sm-6">
            {this.getBenefit(0)}
            {this.getBenefit(1)}
          </div>
          <div className="col-sm-6">
            {this.getBenefit(2)}
            {this.getBenefit(3)}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../src/components/benefits/index.jsx